import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import HeadingLines from '../assets/images/heading-lines.svg' 
import ErrorImg from '../assets/images/404.svg' 

function FourZeroFourErrorSection() {
  return (
    <> 
    <section className="error-section">
      <Container>
        <Row>
          <Col md="12">
              <div className="common-header">
                  <img src={HeadingLines} alt="" />
                  <span className='error-pill'>404 Error</span>
                  <h2>We’ve lost this page</h2> 
                  <p>Sorry, the page you are looking for doesn’t exist or has been moved.</p>
              </div>
              <div className="error-page-box">
               <img src={ErrorImg} alt="" />
              </div>
          </Col>
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default FourZeroFourErrorSection